// extracted by mini-css-extract-plugin
export default {"cookieConsent":"p_br","show":"p_J","consent":"p_bs","content":"p_d","buttonsContainer":"p_bt"};